// removed by extract-text-webpack-plugin
module.exports = {"subHeader":"_3Z38t","arrowDown":"lMv6j"};


//////////////////
// WEBPACK FOOTER
// ./src/views/pages/BlogPage/BlogPage.less
// module id = 962
// module chunks = 0